function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M26.793 17H3a1 1 0 1 1 0-2h23.793L21.5 9.707a1 1 0 0 1 1.414-1.414l6.647 6.646a1.5 1.5 0 0 1 0 2.122l-6.647 6.646a1 1 0 0 1-1.414-1.414L26.793 17z"
});

var SvgArrowRight = function SvgArrowRight(props) {
  return React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "#1B1F23",
    viewBox: "0 0 32 32"
  }, props), _ref);
};

export default __webpack_public_path__ + "eea840ebbb6b8be26423716ef83f10f9.svg";
export { SvgArrowRight as ReactComponent };


//////////////////
// WEBPACK FOOTER
// ../icons/svg/arrow-right.svg
// module id = null
// module chunks = 